(function ($) {
    $(function() {
        let hubspotSubscribe = $("#hubspot-subscribe");
        if (hubspotSubscribe && hubspotSubscribe.length) {
            let wrapperInput = hubspotSubscribe.find(".col-four input");
            //console.log('wrapperInput', wrapperInput);
            
            wrapperInput.on("click", function() {
                if ($(this).hasClass("critical-issues-briefing")) {
                    if ($(this).prop("checked")) {
                        briefingHandler(true);
                    } else {
                        briefingHandler(false);
                    }
                } else {
                    let idAttr = $(this).attr("id");
                    let targetInput = $(`form fieldset input[name=${idAttr}]`);
                    
                    if (targetInput.prop("checked")) {
                        targetInput.prop("checked", false); 
                    } else {
                        targetInput.prop("checked", true);
                    }
                }
                
            });
            
            $(document).on('click', '.cookie-reset-container a', function() {
                $(`.col-four input[type="checkbox"]`).prop('checked', false);
            });

            $(document).on('click', '.checkbox-wrap input[type="checkbox"]', function() {
                const isChecked = $(this).is(':checked');
                
                $('.col-four input[type="checkbox"]').prop('checked', isChecked);
                $('form fieldset input[type="checkbox"]').prop('checked', isChecked);
            });                        

            function briefingHandler(state) {
                console.log('state', typeof state);
                
                let briefingArr = [
                    'subscribed_to_china_briefings',
                    'subscribed_to_economic_briefings',
                    'subscribed_to_state_and_local_briefings',
                    'subscribed_to_national_security_briefings',
                    'subscribed_to_education_briefings',
                    'subscribed_to_history_briefings',
                    'subscribed_to_technology_briefings',
                    'subscribed_to_rai_briefings'
                ];
                briefingArr.forEach(function (name) {
                    console.log(`form fieldset input[name="${name}"]`);
                    $(`form fieldset input[name="${name}"]`).prop('checked', state);
                });
                if (state) {
                    $('.col-four input[id="subscribed_to_rai_briefings"]').parents('.col-four').addClass('show-border');
                } else {
                    $('.col-four input[id="subscribed_to_rai_briefings"]').parents('.col-four').removeClass('show-border');
                }
                $('.col-four input[id="subscribed_to_rai_briefings"]').prop('checked', state);
                
            }
        }
    });
})(jQuery);